export const IconColors = {
    BackgroundFillColor: '#00AFEC',
    BackgroundFillOpacity: 1,
    SymbolFillColor: '#FFFFFF',
    SymbolFillOpacity: 1
};

export const OutdoorSportsIconColors = {
    BackgroundFillColor: '#F9F9F9',
    SymbolFillColor: '#8E8E93',
    width: 31,
    height: 31
};
